import useBetaWorkspaceToggle from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/hooks/useBetaWorkspaceToggle'
import { useLocation } from 'react-router-dom'
import { usePreviewFeatures } from 'shared/hooks/usePreviewFeatures'

// When true, the Harmony (light) header only shows on the project workspace page.
// Flip to false to let Harmony apply app-wide again (still gated by the beta-workspace toggle).
const HARMONY_WORKSPACE_ONLY = true

// Matches /projects/:projectId/workspace and /projects/:projectId/workspace/:elementId.
// Segment-anchored so /preview/:id/workspace/preview/... does NOT match.
const isWorkspacePath = (pathname: string): boolean => {
    const segments = pathname.split('/').filter(Boolean)
    return segments[0] === 'projects' && segments[2] === 'workspace'
}

/** Gates the Harmony (light) header: New Workspace toggle, optionally restricted to the workspace route. */
const useIsHarmonyHeader = (): boolean => {
    const { previewFeatures, loading } = usePreviewFeatures()
    const isBetaWorkspaceEnabled = useBetaWorkspaceToggle()
    const { pathname } = useLocation()
    // Suppress until the flag resolves — avoids a dark-to-Harmony header flash on first paint.
    if (loading || !previewFeatures.hasHarmonyHeader) return false
    if (!HARMONY_WORKSPACE_ONLY) return isBetaWorkspaceEnabled
    return isBetaWorkspaceEnabled && isWorkspacePath(pathname)
}

export default useIsHarmonyHeader
